import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { isEmpty } from 'ts-utils';
import { Color } from '../../config/Color';
import { PaddedAccentContainer } from './ColoredContainers';
import { BodyXS, Heading4, Heading5 } from './Typography';

const backgroundColors = {
  'surface.accent': Color.surface.accent,
  'surface.muted': Color.surface.muted,
  'decorative.muted': Color.decorative.muted,
};

export type ColoredBoxProps = {
  heading?: string;
  title?: string | string[];
  body?: string | string[];
  textAlign?: 'left' | 'center' | 'right' | 'justify';
  borderRadius?: boolean;
  /** Defaults to surface.accent color */
  backgroundColor?: keyof typeof backgroundColors;
};
export const ColoredBox: FunctionComponent<ColoredBoxProps> = (props) => {
  const { heading, title, body, textAlign, backgroundColor, borderRadius = true } = props;

  const _title =
    typeof title === 'string' ? (
      <Title>{title}</Title>
    ) : (
      title?.map((title) => <Title key={title}>{title}</Title>)
    );

  const _body =
    typeof body === 'string' ? (
      <Body>{body}</Body>
    ) : (
      body?.map((body) => <Body key={body}>{body}</Body>)
    );

  return (
    <PaddedAccentContainer
      borderRadius={borderRadius}
      style={{
        textAlign: textAlign,
        backgroundColor: !isEmpty(backgroundColor) ? backgroundColors[backgroundColor] : undefined,
      }}
    >
      {heading !== undefined && <Heading>{heading}</Heading>}
      {_title}
      {_body}
    </PaddedAccentContainer>
  );
};

const Heading = styled(Heading4)`
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
  margin-bottom: ${({ theme }) => theme.spacing._16px};
`;

const Title = styled(Heading5)`
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

const Body = styled(BodyXS)`
  &:last-child {
    margin-bottom: 0;
  }
  white-space: pre-line;
`;
